import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const TimerIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 853 1024",
    fill: "currentColor",
    width: size || '853',
    height: size || '1024'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M456.704 180.224c204.8 22.528 362.496 192.512 361.472 400.384 0 221.184-184.32 402.432-409.6 402.432-224.256 0-408.576-180.224-408.576-402.432 0-206.848 159.744-376.832 362.496-400.384 0 0 0 0 0 0s0-88.064 0-88.064c0 0-97.28 0-97.28 0s0-92.16 0-92.16c0 0 288.768 0 288.768 0s0 92.16 0 92.16c0 0-97.28 0-97.28 0s0 88.064 0 88.064c0 0 0 0 0 0zM96.256 580.608c0 169.984 140.288 309.248 314.368 309.248s314.368-139.264 314.368-309.248c0-169.984-140.288-310.272-314.368-310.272-173.056 0-314.368 138.24-314.368 310.272zM457.728 367.616c0 0 0 166.912 0 166.912s96.256 0 96.256 0c0 0 0 92.16 0 92.16s-189.44 0-189.44 0c0 0 0-92.16 0-92.16s0 0 0 0 0-166.912 0-166.912c0 0 93.184 0 93.184 0z",
    fillRule: "evenodd"
  }));
};
TimerIcon.displayName = 'TimerIcon';
export default TimerIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TimerIcon.js.map